import { useMemo } from 'react';
import { TranscriptUtterance } from '../types';

interface DataMaps {
  utteranceDataMap: Map<string, { utteranceIndex: number; startTime: number }>;
  wordDataMap: Map<
    string,
    { utteranceIndex: number; wordIndex: number; startTime: number }
  >;
}

/**
 * Creates optimized lookup maps for O(1) access to utterance and word data
 * @param utterances - Array of transcript utterances
 * @returns Object containing utteranceDataMap and wordDataMap
 */
export const useTranscriptDataMaps = (
  utterances: TranscriptUtterance[]
): DataMaps => {
  return useMemo(() => {
    const utteranceMap = new Map<
      string,
      { utteranceIndex: number; startTime: number }
    >();
    const wordMap = new Map<
      string,
      { utteranceIndex: number; wordIndex: number; startTime: number }
    >();

    utterances.forEach((utterance, uIndex) => {
      utteranceMap.set(utterance.id, {
        utteranceIndex: uIndex,
        startTime: utterance.startTime,
      });

      utterance.transcriptWords.forEach((word, wIndex) => {
        wordMap.set(word.id, {
          utteranceIndex: uIndex,
          wordIndex: wIndex,
          startTime: word.startTime,
        });
      });
    });

    return {
      utteranceDataMap: utteranceMap,
      wordDataMap: wordMap,
    };
  }, [utterances]);
};
